<template>
  <div class="page-ferie">

    <div class="WEB-actions col-24 no-padding">
      <el-button class="WEB-button WEB-button-header left filtri"
        @click="() => { filtriActive ? closeFiltri() : openFiltri() }">
        <div class="filtri-div">
          <div class="icon-left">
            <icon name="riv-filter" scale="1.4"></icon>
          </div>
          <div class="label">{{ $t('btn.filtri') }}</div>
          <div style="width: 20px"></div>
        </div>
      </el-button>
      <el-button class="WEB-button WEB-button-icon-transparent right prec" @click="changeYear(-1)">
        <icon name="riv-arrow" scale="1.2" flip="horizontal"></icon>
      </el-button>
      <span class="titolo">{{ this.filtro.anno }}</span>
      <el-button class="WEB-button WEB-button-icon-transparent right prec" @click="changeYear(1)">
        <icon name="riv-arrow" scale="1.2"></icon>
      </el-button>
      <el-button class="WEB-button WEB-button-primary right" @click="opAssenze('C')">
        {{ $t('btn.approva').toUpperCase() }}
      </el-button>
    </div>

    <div class="WEB-body col-24 no-padding">

      <!-- Filtri -->
      <div class="WEB-filtri" v-show="filtriActive">
        <div class="WEB-filtri-content">
          <div class="row">
            <!--<div class="WEB-filtri-title col-24">
              {{$t('filtri.selFiltri')}}
            </div>-->
            <div class="WEB-filtri-label col-24">
              {{ $t('ferie.stato') }}
            </div>
            <div class="WEB-filtri-input col-24">
              <el-select v-model="filtro.statoRich" class="WEB-select" value-key="statoRich">
                <el-option v-for="item in stati" :key="item" :label="($t('ferie.status.' + item + '_des'))"
                  :value="item">
                </el-option>
              </el-select>
            </div>
            <div class="WEB-filtri-label col-24">
              {{ $t('ferie.anno') }}
            </div>
            <div class="WEB-filtri-input col-24">
              <el-select v-model="filtro.anno" class="WEB-select" value-key="anno">
                <el-option v-for="item in anni" :key="item" :label="item" :value="item">
                </el-option>
              </el-select>
            </div>
            <div class="WEB-filtri-label col-24" v-if="filtro.auth_VIP">
              {{ $t('calendar.vip') }}
              <el-checkbox v-model="filtro.vip" class="WEB-checkbox" style="margin-left: 20px;"></el-checkbox>
            </div>
          </div>
        </div>

        <div class="filtri-footer row">
          <div class="col-12 filtri-button-sx">
            <el-button class="WEB-button WEB-button-alternative" @click="svuotaCampi()">
              {{ $t('btn.svuotaCampi') }}
            </el-button>
          </div>
          <div class="col-12 filtri-button-dx">
            <el-button class="WEB-button WEB-button-primary central" @click="cerca()">
              {{ $t('btn.cerca') }}
            </el-button>
          </div>
        </div>
      </div>
      <div class="mask-div" v-show="filtriActive" @click="closeFiltri" />
      <!-- END Filtri -->


      <el-table :data="richiesteSub" @row-click="showNote" highlight-current-row width="100%" v-loading="loading"
        class="custom-table table-ferie" :height="100 % - 56 - 60 - 83">

        <el-table-column header-align="center" align="center" width="50">


          <template slot-scope="scope" slot="header">
            <div class="icon-title">
              <el-popover placement="top" v-model="visibleInfo" :key="scope.toString()">
                <div>
                  <div>
                    <icon name="riv-circle" class="status-send" scale="0.8"></icon>
                    <span>{{ $t('ferie.status.A_des') }}</span>
                  </div>
                  <div>
                    <icon name="riv-circle" class="status-approved" scale="0.8"></icon>
                    <span>{{ $t('ferie.status.C_des') }}</span>
                  </div>
                  <div>
                    <icon name="riv-circle" class="status-rejected" scale="0.8"></icon>
                    <span>{{ $t('ferie.status.R_des') }}</span>
                  </div>
                </div>
                <span slot="reference">
                  <icon class="pointer" name="riv-help" scale="1"></icon>
                </span>
              </el-popover>

            </div>
          </template>


          <template slot-scope="scope">
            <div class="data-wrapper">
              <el-tooltip class="item" effect="dark" :content="$t('ferie.status.' + scope.row.stato)"
                placement="top-start">
                <icon name="riv-circle" :class="getStatoClass(scope.row.stato)" scale="0.8"></icon>
              </el-tooltip>
            </div>
          </template>

        </el-table-column>

        <!--<el-table-column
                prop="dataAl" align="center" header-align="center"
                width="40">

                <template slot-scope="scope">
                  <div class="actions">
                    <icon class="pointer" name="riv-protocollo" scale="1.1"
                          @click.native="openModalNote(scope.row)"></icon>
                  </div>
                </template>

              </el-table-column>-->
        <el-table-column prop="dataAl" align="center" header-align="center" width="40">

          <template slot-scope="scope">
            <div class="actions">
              <icon v-if="(scope.row.seGest === 'S')" class="pointer" name="riv-prenotazione" scale="1.1"
                @click.native="openModalRichiesta(scope.row)"></icon>
            </div>
          </template>

        </el-table-column>
        <el-table-column :label="($t('ferie.impiegato'))" min-width="150">

          <template slot-scope="scope">
            <div class="name-wrapper">
              {{ scope.row.cognome + ' ' + scope.row.nome }}
            </div>
          </template>

        </el-table-column>
        <el-table-column prop="descTipoAssenza" header-align="center" :label="($t('ferie.tipo'))" min-width="200">
        </el-table-column>

        <el-table-column header-align="center" align="center" :label="($t('ferie.dt_creazione'))" width="120">

          <template slot-scope="scope">
            <div class="name-wrapper">
              {{ scope.row | getCreationDate }}
            </div>
          </template>

        </el-table-column>

        <el-table-column header-align="center" align="center" :label="($t('ferie.periodo'))" width="250">

          <template slot-scope="scope">
            <div class="name-wrapper">
              {{ scope.row | getPeriodo }}
            </div>
          </template>

        </el-table-column>

        <el-table-column header-align="center" align="center" :label="($t('ferie.orario'))" width="140">

          <template slot-scope="scope">
            <div class="name-wrapper">
              {{ scope.row | getOrario }}
            </div>
          </template>

        </el-table-column>

        <el-table-column header-align="center" align="center" :label="($t('ferie.numOre'))" width="140">

          <template slot-scope="scope">
            <div class="name-wrapper">
              {{ (scope.row.oreAssenza !== '0,00') ? scope.row.oreAssenza : ' ' }}
            </div>
          </template>

        </el-table-column>

        <el-table-column align="center" header-align="center" :label="($t('ferie.dip'))" width="100">

          <template slot-scope="scope">
            <div class="actions" v-if="scope.row.notaDip !== ''">
              <el-tooltip placement="left">
                <div slot="content" v-html="scope.row.notaDip.split('\\n').join('\n')" style="white-space: pre-line">
                </div>
                <icon name="riv-addnotes" scale="1.2"></icon>
              </el-tooltip>
            </div>
          </template>
        </el-table-column>

        <el-table-column align="center" header-align="center" :label="($t('ferie.resp'))" width="100">

          <template slot-scope="scope">
            <div class="actions" v-if="scope.row.notaResp !== ''">
              <el-tooltip placement="left">
                <div slot="content" v-html="scope.row.notaResp.split('\\n').join('\n')" style="white-space: pre-line">
                </div>
                <icon name="riv-addnotes" scale="1.2"></icon>
              </el-tooltip>
            </div>
          </template>
        </el-table-column>

        <el-table-column width="40">

          <template slot-scope="scope" slot="header">
            <div class="icon-check">
              <el-checkbox class="check" @change="checkConvalida"></el-checkbox>
            </div>
          </template>

          <template slot-scope="scope">
            <div v-if="(scope.row.stato === 'A' && scope.row.seGest === 'S')">
              <el-checkbox @click.native.stop v-model="scope.row.checkConvalida"></el-checkbox>
            </div>
          </template>
        </el-table-column>

      </el-table>

      <el-pagination class="custom-pagination" v-if="(nrItems > pag_for)" layout="prev, pager, next"
        :current-page="currentPage" :total="nrItems" :page-size="pag_for" @current-change="changePage">
      </el-pagination>
    </div>

    <el-dialog :title="($t('ferie.titolo').toUpperCase()) + ': ' + richiesta.cognome + ' ' + richiesta.nome"
      :visible.sync="showModalRichiesta" class="custom-dialog" :append-to-body="true" custom-class="offset-7 col-10">
      <el-form class="">

        <div class="elemento row row-custom">
          <div class="my-label col-6 no-padding">
            {{ $t('ferie.tipologia') }}
          </div>
          <div class="my-value col-18 no-padding">
            {{ richiesta.descTipoAssenza }}
          </div>
        </div>
        <div class="elemento row row-custom" v-if="country === '2'">
          <div class="my-label col-6 no-padding">
            {{ $t('ferie.cpf') }}
          </div>
          <div class="my-value col-18 no-padding">
            {{ (richiesta.rinunciaFraz === '1') ? $t('ferie.si').toUpperCase() : $t('ferie.no').toUpperCase() }}
          </div>
        </div>
        <div class="elemento row row-custom">
          <div class="my-label col-6 no-padding">
            {{ $t('ferie.periodo') }}
          </div>
          <div class="my-value col-18 no-padding">
            {{ richiesta | getPeriodo }}
          </div>
        </div>
        <div class="elemento row row-custom" v-if="richiesta.seOre === 'S'">
          <div class="my-label col-6 no-padding">
            {{ $t('ferie.orario') }}
          </div>
          <div class="my-value col-18 no-padding">
            {{ richiesta | getOrario }}
          </div>
        </div>
        <div class="elemento row row-custom" v-if="richiesta.seOre === 'S'">
          <div class="my-label col-6 no-padding">
            {{ $t('ferie.numOre') }}
          </div>
          <div class="my-value col-4 no-padding">
            {{ (richiesta.oreAssenza != undefined) ? richiesta.oreAssenza : richiesta.oreAssenza }}
          </div>
        </div>

        <!--<div class="elemento row row-custom">
          <div class="my-label col-6 no-padding">
            {{ $t('ferie.oreDa') }}
          </div>
          <div class="my-value col-6 no-padding">
            {{ (richiesta.oraIni !== '0,00') ? richiesta.oraIni : '' }}
          </div>
          <div class="my-label col-6 no-padding">
            {{ $t('ferie.oreA') }}
          </div>
          <div class="my-value col-6 no-padding">
            {{ (richiesta.oraFin !== '0,00') ? richiesta.oraFin : '' }}
          </div>
        </div>-->
        <div class="elemento row row-custom">
          <div class="my-label col-6 no-padding">
            {{ $t('ferie.noteDip') }}
          </div>
          <div class="my-value col-18 no-padding">
            {{ richiesta.notaDip }}
          </div>
        </div>
        <div class="elemento row row-custom">
          <div class="my-label col-6 no-padding">
            {{ $t('ferie.noteResp') }}
          </div>
          <div class="my-value col-18 no-padding">
            <el-input type="text" maxlength="60" placeholder="" v-model="notaResp">
            </el-input>
          </div>
        </div>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button class="WEB-button WEB-button-alternative" @click="showModalRichiesta = false">{{ $t('btn.annulla')
          }}</el-button>
        <el-button class="WEB-button WEB-button-alternative" @click="setRichiesta('R')">{{
          $t('btn.rifiuta').toUpperCase()
        }}</el-button>
        <el-button class="WEB-button WEB-button-primary" @click="setRichiesta('C')">{{ $t('btn.approva').toUpperCase()
          }}</el-button>
      </span>

    </el-dialog>

    <el-dialog :title="($t('ferie.note').toUpperCase()) + ': ' + richiesta.cognome + ' ' + richiesta.nome"
      :visible.sync="showModalNote" class="custom-dialog" :append-to-body="true" custom-class="offset-7 col-10">

      <el-form class="">
        <div class="elemento row row-custom">
          <div class="my-label col-6 no-padding">
            {{ $t('ferie.noteDip') }}
          </div>
          <div class="my-value col-18 no-padding">
            {{ richiesta.notaDip }}
          </div>
        </div>
        <div class="elemento row row-custom">
          <div class="my-label col-6 no-padding">
            {{ $t('ferie.noteResp') }}
          </div>
          <div class="my-value col-18 no-padding">
            {{ richiesta.notaResp }}
          </div>
        </div>

      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button class="WEB-button WEB-button-alternative" @click="showModalNote = false">{{ $t('btn.annulla')
          }}</el-button>
      </span>

    </el-dialog>

  </div>
</template>

<script>
import moment from 'moment'

export default {
  name: 'Autorizzazioni',
  props: ['tableHeight'],
  data() {
    return {// filtri
      filtriActive: false,
      filtro: {
        anno: 0,
        statoRich: 'A',
        auth_VIP: false,
        vip: false
      },
      country: "",
      loading: false,
      currentPage: 1,
      pag_for: 100,
      anni: [],
      //countries: [],
      stati: ['T', 'C', 'A', 'R'],
      richiesteSub: [],
      nrItems: 0,
      richiesta: {},
      showModalRichiesta: false,
      showModalNote: false,
      notaResp: '',
      notaDip: '',
      visibleInfo: false
    }
  },
  filters: {
    formatDate: function (date) {
      if (date !== '' && date !== undefined && date !== null) {
        return date.substr(6, 2) + '/' + date.substr(4, 2) + '/' + date.substr(0, 4)
      } else {
        return '-'
      }
    },
    getCreationDate: function (row) {
      if (row.id === undefined || row.id === '' || row.id.length < 10) {
        return ''
      } else {
        return moment(row.id.substr(0, 10), "YYYY-MM-DD").format("DD/MM/YYYY")
      }
    },
    getPeriodo: function (row) {
      if (row.dataDal === undefined || row.dataAl === undefined) {
        return ''
      } else if (row.dataDal === row.dataAl) {
        return row.dataDal.substr(6, 2) + '/' + row.dataDal.substr(4, 2) + '/' + row.dataDal.substr(0, 4)
      } else {
        return row.dataDal.substr(6, 2) + '/' + row.dataDal.substr(4, 2) + '/' + row.dataDal.substr(0, 4) + ' - ' +
          row.dataAl.substr(6, 2) + '/' + row.dataAl.substr(4, 2) + '/' + row.dataAl.substr(0, 4)
      }
    },
    getOrario: function (row) {
      if (row.oraIni === undefined || row.oraFin === undefined) {
        return ''
      } else if (row.oraIni === '0,00' && row.oraFin === '0,00') {
        return ''
      } else if (row.oraIni !== '' && row.oraFin !== '') {
        return (row.oraIni.length === 4 ? '0' + row.oraIni : row.oraIni) + ' - ' + (row.oraFin.length === 4 ? '0' + row.oraFin : row.oraFin)
      } else {
        return ''
      }
    }
  },
  activated: function () {
    this.country = this.$store.state.country
    let anno = new Date().getFullYear()
    this.$set(this.filtro, 'anno', anno)
    this.anni = [anno - 1, anno, anno + 1]
    this.checkauth('authCongeVIP')
    this.ricerca()
    //this.getCountries()
  },
  deactivated: function () {
    this.country = ""
    this.loading = false
    let filtro = {
      anno: 0,
      statoRich: 'A',
      auth_VIP: false,
      vip: false
    }
    this.$set(this, 'filtro', filtro)
    this.currentPage = 1
    this.$set(this, 'anni', [])
    //this.$set(this, 'countries', [])
    this.$set(this, 'stati', ['T', 'C', 'A', 'R'])
    this.$set(this, 'richiesteSub', [])
    this.nrItems = 0
    this.$set(this, 'richiesta', {})
    this.showModalRichiesta = false
    this.showModalNote = false
    this.notaResp = ''
    this.notaDip = ''
    this.visibleInfo = false
  },
  methods: {
    // GESTIONE FILTRI
    openFiltri: function () {
      this.filtriActive = true
    },
    closeFiltri: function () {
      this.filtriActive = false
    },
    svuotaCampi: function () {
      this.$set(this.filtro, 'company', '')
      this.$set(this, 'list_Groups', [])
      this.$set(this.filtro, 'group', '')
      this.$set(this, 'list_CecoCoi', [])
      this.$set(this.filtro, 'cecoCoi', '')
      this.$set(this.filtro, 'typologies', [])
      this.filtro.typologies.push('*')
    },
    changeYear: function (value) {
      this.$set(this.filtro, 'anno', this.filtro.anno + value)
      this.currentPage = 1
      this.ricerca()
    },
    cerca: function () {
      this.currentPage = 1
      this.filtriActive = false
      this.ricerca()
    },
    // END GESTIONE FILTRI
    openModalRichiesta: function (rich) {
      this.$set(this, 'richiesta', rich)
      this.showModalRichiesta = true
    },
    openModalNote: function (rich) {
      this.$set(this, 'richiesta', rich)
      this.showModalNote = true
    },
    changePage: function (page) {
      this.currentPage = page
      this.ricerca()
    },
    change: function () {
      this.ricerca()
    },
    checkauth: function (auth) {
      this.loading = true
      this.$http.get("dipendente/" + this.country + '/checkauth', {
        params: {
          auth: auth
        }
      })
        .then(response => {
          if (response.body.rc === 0) {
            this.filtro.auth_VIP = true
          } else {
            this.filtro.auth_VIP = false
          }
          this.loading = false
        })
    },
    ricerca: function () {
      this.loading = true
      this.$http.get('ferie/' + this.country + '/richiestesub', {
        params: {
          pag_action: (this.currentPage === 1) ? 'BEGIN' : 'NEXT',
          pag_for: this.pag_for,
          pag_from: this.currentPage,
          anno: this.filtro.anno,
          statoRich: (this.filtro.statoRich === 'T') ? '' : this.filtro.statoRich,
          VIP: (this.filtro.vip) ? '1' : null
        }
      })
        .then(response => {
          if (response.body.rc === 0) {
            //this.$set(this, 'richiesteSub', response.body.data)
            this.richiesteSub = response.body.data.map(obj => ({
              ...obj,
              checkConvalida: false
            }));
            if (this.currentPage === 1) {
              this.$set(this, 'nrItems', parseInt(response.body.attrib.size))
            }
          } else {
            this.$set(this, 'richiesteSub', [])
            this.currentPage = 1
            this.nrItems = 0
          }
          this.loading = false
        })
    },
    setRichiesta: function (stato) {
      let country = this.richiesta.country
      let obj = {
        notaRes: this.notaResp,
        id: this.richiesta.id,
        stato: stato
      }
      this.$http.post('ferie/' + country + '/richiestaupdate', obj, { emulateJSON: true })
        .then(response => {
          if (response.body.rc === 0) {
            this.showModalRichiesta = false
            this.ricerca()
          } else {
            this.$message({
              showClose: true,
              message: response.body.msg[0].msgTxt,
              type: 'error',
              duration: process.env.duration
            })
          }
        })
    },
    checkConvalida(event) {
      this.richiesteSub.forEach(assenza => {
        if (assenza.stato === 'A' && assenza.seGest === 'S') {
          assenza.checkConvalida = event;
        }
      })
    },
    opAssenze(statoAvanz) {
      const message = this.$i18n.t('ferie.confApp');
      const btnOK = this.$i18n.t('btn.approva');
      const btnCancel = this.$i18n.t('btn.annulla');

      this.$confirm(message, 'Info', {
        confirmButtonText: btnOK,
        cancelButtonText: btnCancel,
        type: 'info',
        callback: (action) => {
          if (action !== 'confirm') {
            this.$message({
              showClose: true,
              message: this.$i18n.t('trasferte.msg.abort'),
              type: 'info',
              duration: process.env.duration
            });
            return;
          }

          const righe = this.richiesteSub
            .filter(item => item.checkConvalida)
            .map(item => ({
              id: item.id,
              country: item.country
            }));

          if (righe.length === 0) {
            this.$message({
              showClose: true,
              message: this.$i18n.t('ferie.noDocsSel'),
              type: 'warning',
              duration: process.env.duration
            });
            return;
          }

          this.loading = true;
          const payload = {
            stato: 'C',
            assenze: righe
          }

          this.$http.post(`ferie/${this.$store.state.country}/richieste`, payload, {
              params: {
                codLang: sessionStorage.getItem('codLang')
              },
              headers: {
                'Content-Type': 'application/json'
              }
            })
            .then(response => {
              const { rc, msg } = response.body;
              this.$message({
                showClose: true,
                message: msg[0].msgTxt,
                type: rc === 0 ? 'success' : 'warning',
                duration: process.env.duration
              });
              if (rc === 0) this.ricerca();
            })
            .finally(() => {
              this.loading = false;
            });
          }
      });
    },
    showNote: function (row, event, column) {
      this.notaDip = row.notaDip
      this.notaResp = row.notaResp
    },
    getStatoClass: function (stato) {
      switch (stato) {
        case 'A':
          return 'status-send'
        case 'C':
          return 'status-approved'
        case 'R':
          return 'status-rejected'
        default:
          return ''
      }
    }
  }
}
</script>


<style lang="less">
@import "../../assets/less/general.less";

.page-ferie {
  .WEB-actions {
    .prec {
      padding-right: 20px;
      float: none;
    }

    .succ {
      padding-right: 20px;
      float: none;
    }

    .el-date-editor {
      .el-input__inner:hover {
        cursor: pointer;
      }

      .el-input__inner {
        height: 22px;
        line-height: 22px;
        border: 0px;
        border-bottom: 1px solid #e7e7e7;
        border-radius: 0px;
        padding-left: 25px;
        padding-right: 10px;
        width: 150px;
        text-align: center;
      }

      .el-input__prefix {
        left: -5px;

        .el-input__icon {
          line-height: 22px;
        }
      }
    }

    .el-select {

      //margin-left: 20px;
      .el-input__inner {
        height: 22px;
        line-height: 22px;
        border: 0px;
        border-bottom: 1px solid #e7e7e7;
        border-radius: 0px;
        padding-left: 0px;
        padding-right: 10px;
      }

      .el-input__suffix {
        right: -5px;
      }
    }

    .el-checkbox {
      .el-checkbox__inner {
        border-radius: 0px;
      }

      &.is-checked {
        .el-checkbox__inner {
          background-color: @greenRiva;
          border-color: @greenRiva;
        }
      }
    }

    .header-label {
      .set-font(@size: 14px; @weight: bold);
    }

    .header-value {
      .set-font(@size: 14px; @color: #666);
    }

    .action {
      float: right;
      text-align: right;
    }
  }

  .table-ferie {
    margin-top: 20px;
    // WEB-header (56px) - WEB-title (50px) WEB-Action (50px) WEB-paginator (60px) - MArgin-top (10px)
    height: calc(100vh - 56px - 50px - 50px - 60px - 5px - 10px);
  }
}

.autorizzazioni-ferie {
  height: 100%;
  padding: 0;

  .riepilogo {
    height: 100%;
    padding-right: 15px;
    padding-left: 15px;

    .elemento {
      line-height: 40px;

      .titolo {
        height: 60px;
        line-height: 30px;
        text-align: left;
        padding-top: 15px;
        padding-bottom: 15px;
        letter-spacing: 3px;
        text-transform: uppercase;
        .set-font(@size: 16px, @color: @oroRiva, @weight: bold, @family: 'os-regular');
      }

      .my-label {
        text-align: left;
        .set-font(@size: 14px, @color: @greenRiva, @weight: bold, @family: 'os-regular');
      }

      .my-value {
        text-align: right;
        .set-font(@size: 14px, @color: @textTable, @family: 'os-regular');

        .el-select {
          .el-input__inner {
            height: 22px;
            line-height: 22px;
            border: 0px;
            border-bottom: 1px solid #e7e7e7;
            border-radius: 0px;
            padding-left: 0px;
            padding-right: 10px;
          }

          .el-input__suffix {
            right: -5px;
          }
        }

        .anno {
          .el-select {
            .el-input__inner {
              width: 55px;
            }
          }
        }

        .stato {
          .el-select {
            width: 90%;
          }
        }
      }
    }
  }

  .elenco {
    height: calc(100vh - 56px - 66px);
    padding: 10px;

    .box {
      padding-top: 10px;
      overflow: auto;
      background-color: #f2f2f2;
      border-radius: 5px;

      .action {
        height: 80px;

        .filter {
          margin-top: 10px;
          text-align: left;
          line-height: 40px;

          .iconArrow {
            cursor: pointer;
            display: inline-block;
            position: relative;
            top: -2px;
            .set-font(@color: @oroRiva, @weight: bold, @family: 'os-regular');
          }

          span {
            .set-font(@size: 16px, @color: @greenRiva, @weight: bold, @family: 'os-regular');
          }
        }
      }

      .el-table {
        background-color: #f2f2f2;

        .el-table__header {
          thead {
            tr {
              background-color: #f2f2f2;
            }

            th {
              background-color: #f2f2f2;
            }
          }
        }
      }

      .el-table__body {
        .el-table__row {
          background-color: #f2f2f2;
        }

      }
    }

    .table-ferie {
      height: calc(100vh - 56px - 60px - 82px);
    }
  }

  .note {
    padding: 10px 10px 10px 0px;

    .box {
      border: 1px solid #f2f2f2;

      .note-dip,
      .note-resp {
        .my-label {
          text-align: left;
          margin: 10px;
          border-bottom: 2px solid @greenRiva;

          padding-bottom: 5px;
          .set-font(@size: 16px, @color: @greenRiva, @weight: bold, @family: 'os-regular');
        }

        .my-value {
          text-align: left;
          margin: 10px;
          .set-font(@size: 14px, @color: @textTable, @family: 'os-regular');
        }

        height: 150px;
      }
    }

  }

}

.status-saved {
  color: @grayMedium;
}

.status-send {
  color: @orangeMedium;
}

.status-approved {
  color: @greenApproved
}

.status-rejected,
.status-delete {
  color: #f44336
}
</style>



// WEBPACK FOOTER //
// src/components/Ferie/Autorizzazioni.vue